import { useState, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { registerUser } from "../redux/slices/authSlice"
import AuthLayout from "../components/AuthLayout"

import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const RegisterPage = () => {
  const dispatch = useDispatch()
  const { registerStatus, registerError } = useSelector((state) => state.auth)

  const [showPassword, setShowPassword] = useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    username: "",
    email: "",
    password: "",
    confirmPassword: "",
    acceptTerms: false,
  })

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }))
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    if (formData.password !== formData.confirmPassword) {
      toast.error("Passwords do not match")
      return
    }

    if (!formData.acceptTerms) {
      toast.error("You must accept the terms")
      return
    }

    const userData = {
      first_name: formData.firstName,
      last_name: formData.lastName,
      username: formData.username,
      email: formData.email,
      password: formData.password,
      confirm_password: formData.confirmPassword,
    }

    dispatch(registerUser(userData))
  }

  useEffect(() => {
    if (registerStatus === "succeeded") {
      toast.success("Registration successful!")
    } else if (registerStatus === "failed") {
      let errorMsg = "Registration failed.";
      if (registerError && typeof registerError === "object") {
        // Collect all field errors (e.g. password, username, email)
        errorMsg = Object.entries(registerError)
          .map(([field, errors]) => {
            // errors is usually an array of strings
            if (Array.isArray(errors)) {
              return errors.join(" ");
            }
            return typeof errors === "string" ? errors : "";
          })
          .join(" ");
      } else if (typeof registerError === "string") {
        errorMsg = registerError;
      }
      toast.error(errorMsg);
    }
  }, [registerStatus])

  return (
    <AuthLayout activeTab="register">

      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-md-6 mb-3">
            <label htmlFor="firstName" className="form-label text-muted">
              First Name <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              id="firstName"
              name="firstName"
              value={formData.firstName}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="col-md-6 mb-3">
            <label htmlFor="lastName" className="form-label text-muted">
              Last Name <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              id="lastName"
              name="lastName"
              value={formData.lastName}
              onChange={handleInputChange}
              required
            />
          </div>
        </div>

        <div className="mb-3">
          <label htmlFor="username" className="form-label text-muted">
            Username <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            className="form-control custom-input"
            id="username"
            name="username"
            value={formData.username}
            onChange={handleInputChange}
            required
          />
        </div>

        <div className="mb-3">
          <label htmlFor="email" className="form-label text-muted">
            Email <span className="text-danger">*</span>
          </label>
          <input
            type="email"
            className="form-control"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleInputChange}
            placeholder="Email"
            required
          />
        </div>

        <div className="small text-muted mt-2 ps-1" style={{ lineHeight: 1.5 }}>
        <strong>Password must have:</strong>
        <ul className="mb-0 ps-3">
          <li>At least 8 characters</li>
          <li>Not too similar to your personal information</li>
          <li>Not a commonly used password</li>
          <li>Cannot be entirely numeric</li>
        </ul>
      </div>

        <div className="mb-3 mt-2">
          <label htmlFor="password" className="form-label text-muted">
            Password <span className="text-danger">*</span>
          </label>
          <div className="position-relative">
            <input
              type={showPassword ? "text" : "password"}
              className="form-control custom-input"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleInputChange}
              placeholder="Password"
              required
            />
            <button
              type="button"
              className="btn btn-link position-absolute end-0 top-50 translate-middle-y pe-3"
              onClick={() => setShowPassword(!showPassword)}
              style={{ border: "none", background: "none", color: "#dc3545" }}
            >
              <i className={`fas ${showPassword ? "fa-eye-slash" : "fa-eye"}`}></i>
            </button>
          </div>
        </div>

        <div className="mb-3">
          <label htmlFor="confirmPassword" className="form-label text-muted">
            Confirm Password <span className="text-danger">*</span>
          </label>
          <div className="position-relative">
          <input
            type={showConfirmPassword ? "text" : "password"}
            className="form-control"
            id="confirmPassword"
            name="confirmPassword"
            value={formData.confirmPassword}
            onChange={handleInputChange}
            placeholder="Confirm Password"
            required
          />
          <button
              type="button"
              className="btn btn-link position-absolute end-0 top-50 translate-middle-y pe-3"
              onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              style={{ border: "none", background: "none", color: "#dc3545" }}
            >
              <i className={`fas ${showConfirmPassword ? "fa-eye-slash" : "fa-eye"}`}></i>
            </button>
          </div>
        </div>

        <div className="mb-3">
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              id="acceptTerms"
              name="acceptTerms"
              checked={formData.acceptTerms}
              onChange={handleInputChange}
              required
            />
            <label className="form-check-label text-muted" htmlFor="acceptTerms">
              I Accept{" "}
              <a href="#" className="text-warning">
                the Terms and Conditions
              </a>
              .
            </label>
          </div>
        </div>

        <button type="submit" className="btn btn-primary w-100 custom-btn">
          Register
        </button>
      </form>
    </AuthLayout>
  )
}

export default RegisterPage
